module.exports = import("https://cdn.skypack.dev/@mediapipe/tasks-vision@0.10.0");;